// ABOUTME: Checkmark icon component for confirmation/selection states
// ABOUTME: Supports className, size, and color customization

interface CheckIconProps {
  className?: string
  size?: number
  color?: string
}

export const CheckIcon = ({ className = "", size = 18, color = "currentColor" }: CheckIconProps) => (
  <svg
    width={size}
    height={Math.round((size * 13) / 18)}
    viewBox="0 0 18 13"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.7363 1.67429L6.7363 12.6743C6.67245 12.7382 6.59663 12.7889 6.51317 12.8235C6.4297 12.8581 6.34024 12.8759 6.24989 12.8759C6.15955 12.8759 6.07008 12.8581 5.98662 12.8235C5.90316 12.7889 5.82734 12.7382 5.76349 12.6743L0.950988 7.86179C0.821985 7.73279 0.749512 7.55782 0.749512 7.37538C0.749512 7.19294 0.821985 7.01798 0.950988 6.88898C1.07999 6.75997 1.25496 6.6875 1.43739 6.6875C1.61983 6.6875 1.7948 6.75997 1.9238 6.88898L6.24989 11.2159L16.7635 0.701476C16.8925 0.572473 17.0675 0.5 17.2499 0.5C17.4323 0.5 17.6073 0.572473 17.7363 0.701476C17.8653 0.830479 17.9378 1.00544 17.9378 1.18788C17.9378 1.37032 17.8653 1.54529 17.7363 1.67429Z" />
  </svg>
)
